import { Component, Input, OnInit } from '@angular/core';
import {IFlowChartDataService} from "../../../services/flow-chart-data.service";

@Component({
    standalone: false,
    selector: 'particle-flow-chart-collapsible-view',
  templateUrl: './flow-chart-collapsible-view.component.html',
  styleUrls: ['./flow-chart-collapsible-view.component.scss']
})
export class FlowChartCollapsibleViewComponent implements OnInit {
  isExpanded: boolean;
  @Input() section: any;
  @Input() sourceType: string;
  @Input() flowChartDataService: IFlowChartDataService;
  constructor() { }

  ngOnInit() {
  }
  changeExpand(isExpanded: boolean) {

  }
}
